import React, { memo } from 'react';
import classNames from 'classnames';
import { PencilIcon } from '../../../components/icons';

const getValidationErrorMessage = (validationErrors, typeId) => {
	const found = validationErrors.find((item) => item.typeId === typeId);
	return found && found.message;
};

const EmployeeIdsSection = ({ data, isEditMode, validationErrors, onChange, onEdit }) => {
	if (data.length === 0) return '';

	if (!isEditMode) {
		return (
			<div className="name-and-licenses__wrapper">
				<div className="d-flex justify-content-between">
					<h2>Employee IDs</h2>
					{onEdit && (
						<button type="button" className="edit-button" onClick={onEdit}>
							<PencilIcon color="#7200A0" width={12} height={12} />
							Edit
						</button>
					)}
				</div>
				<div className="home-details__wrapper">
					{data.map((item) => (
						<div key={item.type_id} className="d-flex justify-content-between">
							<h3>
								{item.name} {item.is_primary && <strong>(primary ID)</strong>}
							</h3>
							<h4>{item.value || ' - '}</h4>
						</div>
					))}
				</div>
			</div>
		);
	}

	return (
		<div className="name-and-licenses__wrapper">
			<h2>Employee IDs</h2>
			{data.map((item, index) => (
				<div
					className={classNames('form-field', {
						'validation-error': !!getValidationErrorMessage(validationErrors, item.type_id)
					})}
					key={item.type_id}
				>
					<div className="input-label">
						<span className="label-name">
							{item.name} {item.is_primary && <strong>(primary ID)</strong>}
						</span>
					</div>
					<input
						className="input form-input"
						type="text"
						maxLength={50}
						value={item.value || ''}
						placeholder={item.name}
						onChange={(e) => onChange(index, e.target.value)}
					/>
					<div className="error-message">{getValidationErrorMessage(validationErrors, item.type_id)}</div>
				</div>
			))}
		</div>
	);
};

export default memo(EmployeeIdsSection);
